module.exports = __webpack_public_path__ + "img/layoutselect.584aef61.svg";